import * as React from 'react';
import { AppContextConsumer, AppContext } from '@store/context';

const context = <P extends AppContext>(Component: React.ComponentType<P>) => (props: any) => (
  <AppContextConsumer>
    {
      (appContext: AppContext) => appContext && (
        <Component {...props} on={appContext.on} /> 
      )
    }
  </AppContextConsumer>
);

export default context;


// WEBPACK FOOTER //
// ./src/hoc/context.tsx